module.exports = __webpack_public_path__ + "static/media/logo.864b50fe.png";